var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcImageAdd24X24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Zm-4.453 10.607L13.19 15.95l-2.547-4.41a1.195 1.195 0 0 0-2.067 0L5.141 17.49c-.401.693.1 1.56.9 1.56h11.917a1.04 1.04 0 0 0 .9-1.56l-2.245-3.882a1.195 1.195 0 0 0-2.066 0Zm1.603-2.887c-.24 0-.43-.19-.43-.43V8.14h-2.14c-.24 0-.43-.19-.43-.43s.19-.43.43-.43h2.14V5.14c0-.24.19-.43.43-.43s.43.19.43.43v2.14h2.14c.24 0 .43.19.43.43s-.19.43-.43.43h-2.14v2.14c0 .24-.19.43-.43.43v.01Z",
  fill: "#8B97A7"
})));
export default SvgIcImageAdd24X24;